import {Fragment, ReactNode} from 'react';
import {Dialog, DialogPanel, DialogTitle, Transition, TransitionChild} from '@headlessui/react';

interface TransitionModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}

export function TransitionModal({isOpen, onClose, title, children}: TransitionModalProps) {
  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog as="div" onClose={onClose}>
        <div className="fixed inset-0 ">
          <div className="flex min-h-full justify-center sm:items-center">
            <TransitionChild
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <DialogPanel className="relative transform rounded-lg bg-white text-left transition-all w-full sm:max-w-2xl outline outline-gray-300">
                <div className="px-4 pb-4 pt-5 sm:p-6">
                  <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left text-gray-700">
                    <DialogTitle className="font-bold">{title}</DialogTitle>
                    {children}
                  </div>
                </div>
              </DialogPanel>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
